import { Component } from '@angular/core';

@Component({
  selector: 'app-termos-servicos',
  templateUrl: './termos-servicos.component.html',
  styleUrls: ['./termos-servicos.component.sass']
})
export class TermosServicosComponent {

}
